import { render } from "./AddPayroll.vue?vue&type=template&id=7c1c3d19"
import script from "./AddPayroll.vue?vue&type=script&lang=js"
export * from "./AddPayroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__